import React from "react";
import ShortcutDialogSkeleton from "./shortcutDialogSkeleton";
import { Shortcut, ShortcutUpdateModelv1 } from "modules/shortcuts/models";
import { Audience } from "modules/audiences";

interface IEditShortcutDialogProps {
    show: boolean;
    onClose: () => void;
    onUpdateShortcutFromInput: (input: ShortcutUpdateModelv1) => void;
    audiences: Audience[];
    shortcut: Shortcut;
    shortcutGroupId: string;
}

const EditShortcutDialog: React.FC<IEditShortcutDialogProps> = ({
    show,
    onClose,
    onUpdateShortcutFromInput,
    audiences,
    shortcut,
    shortcutGroupId
}) => {
    return <ShortcutDialogSkeleton
        show={show}
        onClose={onClose}
        onDialogActionButtonClick={onUpdateShortcutFromInput}
        audiences={audiences}
        dialogTitle="Edit Shortcut"
        dialogActionButtonLabel="Save Changes"
        input={{ ...shortcut, groupId: shortcutGroupId }}
        disableActionButtonIfInputNotChanged
    />;
};

export default EditShortcutDialog;
